import React from 'react';

import { EmailAccountInfrastructureServiceProvider } from '../../../enums/create-email-infrastructure';

import {
  Google30x30 as Google,
  Microsoft30x30 as Microsoft,
  MailDoso,
  InfraMail,
  Azure30x30 as AzureIcon,
} from '../../../../../shared/svg';

interface IProps {
  esp: EmailAccountInfrastructureServiceProvider;
  size?: 'sm' | 'lg';
}

const EmailInfrastructureServiceProvider: React.FC<IProps> = ({
  esp,
  size = 'sm',
}) => {
  const renderESPIcon = () => {
    if (esp === EmailAccountInfrastructureServiceProvider.Google) {
      if (size === 'sm') {
        return <Google width={20} height={20} />;
      }
      return <Google />;
    }

    if (esp === EmailAccountInfrastructureServiceProvider.Microsoft) {
      if (size === 'sm') {
        return <Microsoft width={20} height={20} />;
      }
      return <Microsoft />;
    }

    if (esp === EmailAccountInfrastructureServiceProvider.MailDoso) {
      if (size === 'sm') {
        return <MailDoso width={20} height={20} />;
      }
      return <MailDoso />;
    }

    if (esp === EmailAccountInfrastructureServiceProvider.Inframail) {
      if (size === 'sm') {
        return <InfraMail width={20} height={20} />;
      }
      return <InfraMail />;
    }

    if (esp === EmailAccountInfrastructureServiceProvider.Azure) {
      if (size === 'sm') {
        return <AzureIcon width={16} height={16} />;
      }
      return <AzureIcon width={26} height={26} />;
    }

    return null;
  };

  return <>{renderESPIcon()}</>;
};

export default EmailInfrastructureServiceProvider;
